module.exports = __webpack_public_path__ + "static/media/logo.1742d93f.svg";